import React from "react";
import { useTheme } from "../contexts/ThemeContext";

export default function LoadingSpinner({ className = "" }) {
  const { theme } = useTheme();

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <svg className={theme === "dark" ? "animate-spin h-8 w-8 text-white" : "animate-spin h-8 w-8 text-indigo-600"} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z"></path>
      </svg>
    </div>
  );
}
